import { defineFurniture } from './types.js';

/** A bar to build alongside the kopitiam set: counter, stools, shelving and tables. */
export const BAR_FURNITURE = {
  ...defineFurniture('bar', {
    bar_counter: {
      label: 'Bar Counter',
      description: 'Stand next to it to order a drink.',
      price: 450,
      solid: true,
      service: true,
      height: 1.1,
    },
    bar_counter_black: {
      label: 'Black Bar Counter',
      description: 'Black-lacquered, with a chrome foot rail. Stand next to it to order a drink.',
      price: 450,
      solid: true,
      service: true,
      height: 1.1,
    },
    bar_counter_silver: {
      label: 'Silver Bar Counter',
      description: 'Brushed steel from top to toe. Stand next to it to order a drink.',
      price: 450,
      solid: true,
      service: true,
      height: 1.1,
    },
    pub_stool: {
      label: 'Pub Stool',
      description: 'Tall and chrome-legged.',
      price: 130,
      solid: false,
      seat: 'free',
      height: 0.75,
    },
    pub_stool_red: {
      label: 'Red Pub Stool',
      description: 'Tall and chrome-legged, with a red lacquered seat.',
      price: 130,
      solid: false,
      seat: 'free',
      height: 0.75,
    },
    pub_stool_black: {
      label: 'Black Pub Stool',
      description: 'Tall and chrome-legged, with a black lacquered seat.',
      price: 130,
      solid: false,
      seat: 'free',
      height: 0.75,
    },
    back_bar_shelf: {
      label: 'Back Bar Shelf',
      description: 'Bottles lined up and lit from below.',
      price: 380,
      solid: true,
      height: 2,
    },
    back_bar_shelf_black: {
      label: 'Black Back Bar Shelf',
      description: 'Matte black frame, bottles lined up and lit from below.',
      price: 380,
      solid: true,
      height: 2,
    },
    back_bar_shelf_silver: {
      label: 'Silver Back Bar Shelf',
      description: 'Brushed steel frame, bottles lined up and lit from below.',
      price: 380,
      solid: true,
      height: 2,
    },
    cocktail_table: {
      label: 'Cocktail Table',
      description: 'A tall round table for standing around.',
      price: 220,
      solid: true,
      height: 1,
    },
    neon_sign: {
      label: 'Neon Sign',
      description: 'Glows pink after dark.',
      price: 260,
      solid: false,
      height: 1.8,
    },
  }),
};
